import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';

import { ApiError } from './api/client';
import { AuthProvider } from './auth/AuthProvider';
import { Layout } from './components/Layout';
import { AdvisorsPage } from './features/advisors/AdvisorsPage';
import { MonthlyPage } from './features/monthly/MonthlyPage';
import { ReportsPage } from './features/reports/ReportsPage';
import { TeamsPage } from './features/teams/TeamsPage';
import { UsersPage } from './features/users/UsersPage';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
    },
  },
});

const routes = [
  {
    element: <Layout />,
    children: [
      { index: true, element: <Navigate to="/datos" replace /> },
      { path: 'datos', element: <MonthlyPage /> },
      { path: 'informes', element: <ReportsPage /> },
      { path: 'asesores', element: <AdvisorsPage /> },
      { path: 'equipos', element: <TeamsPage /> },
      { path: 'usuarios', element: <UsersPage /> },
      { path: '*', element: <Navigate to="/datos" replace /> },
    ],
  },
];

/** Created only once the session exists, i.e. after the IDHub callback has
 *  restored the page the user originally asked for. */
function AppRouter() {
  const [router] = useState(() => createBrowserRouter(routes));
  return <RouterProvider router={router} />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
